module.exports = __webpack_public_path__ + "static/images/pg.330f79b.jpg";